/**
 * Normalize a player path to the canonical { points, speed, delay } shape so we
 * stay backward-compatible with older plays that stored just a points array.
 */
export function normalizePath(p) {
  if (!p) return null;
  if (Array.isArray(p)) return { points: p, speed: 1.0, delay: 0 };
  if (Array.isArray(p.points)) return {
    points: p.points,
    speed: typeof p.speed === 'number' ? p.speed : 1.0,
    delay: typeof p.delay === 'number' ? p.delay : 0,
  };
  return null;
}

export const SPEED_PRESETS = [
  { id: 'slow', label: 'Lento', short: '0.7×', value: 0.7, emoji: '🐢' },
  { id: 'normal', label: 'Normal', short: '1×', value: 1.0, emoji: '' },
  { id: 'fast', label: 'Rápido', short: '1.5×', value: 1.5, emoji: '' },
  { id: 'sprint', label: 'Sprint', short: '2×', value: 2.0, emoji: '🚀' },
];

export const DELAY_PRESETS = [
  { id: 'now', label: 'Ya', short: '0s', value: 0 },
  { id: 'short', label: 'Corto', short: '0.3s', value: 0.3 },
  { id: 'mid', label: 'Medio', short: '0.6s', value: 0.6 },
  { id: 'long', label: 'Largo', short: '1s', value: 1.0 },
];

export function speedPresetFor(v) {
  const closest = SPEED_PRESETS.reduce(
    (acc, p) => (Math.abs(p.value - v) < Math.abs(acc.value - v) ? p : acc),
    SPEED_PRESETS[1]
  );
  return closest;
}

export function delayPresetFor(v) {
  const closest = DELAY_PRESETS.reduce(
    (acc, p) => (Math.abs(p.value - v) < Math.abs(acc.value - v) ? p : acc),
    DELAY_PRESETS[0]
  );
  return closest;
}
